import { PersonalInsightsDashboard } from '@/components/insights/PersonalInsightsDashboard';

export default function PersonalInsights() {
  return (
    <div className="container mx-auto py-8 px-4 max-w-6xl">
      <PersonalInsightsDashboard />
    </div>
  );
}
